/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import {
  FileUploadStreamInitialProps as FileUploadStreamInitialProperties,
  NewProgressProps as NewProgressProperties,
  SingleFileUploadProgress,
} from '../../interface/file-upload-stream.interface';

// Initial state
const initialState: FileUploadStreamInitialProperties = {
  fileUploadProgress: [],
};

// Create the slice
export const fileUploadSlice = createSlice({
  name: 'station-management',
  initialState,
  reducers: {
    /**
     * Update upload progress
     * @param {any} state - The current state.
     * @param {any} action - The action object.
     */
    updateFileUploadProgress: (state, action) => {
      const newProgress: NewProgressProperties = {
        fileName: action.payload.fileName,
        percentage: Number(action.payload?.percentage),
      };
      const fileUploadList: SingleFileUploadProgress[] = state.fileUploadProgress; // Assign the existing content to another variable
      const existingProgressIndex: number = fileUploadList.findIndex(
        (fileUpload) =>
          fileUpload.fileName === newProgress.fileName && fileUpload.status === 'pending',
      );
      const newFileUploadList: SingleFileUploadProgress[] = fileUploadList.map((uploadList) => ({
        ...uploadList,
        currentlyUploading: false,
      }));
      if (existingProgressIndex !== -1) {
        newFileUploadList[existingProgressIndex] = {
          fileName: newProgress.fileName,
          progress: newProgress.percentage,
          currentlyUploading: true,
          status: newProgress.percentage === 100 ? 'uploaded' : 'pending',
        };
      }
      state.fileUploadProgress = newFileUploadList;
    },
    /**
     * Set initial state for file upload progress
     * @param {any} state - The current state.
     * @param {any} action - The action object.
     */
    setUnUploadedFileData: (state, action) => {
      state.fileUploadProgress = action.payload;
    },
  },
});

// Export the actions
export const { updateFileUploadProgress, setUnUploadedFileData } = fileUploadSlice.actions;

// Export the reducer
export default fileUploadSlice.reducer;
